import type { CSSObject } from 'tss-react';
import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

const drawerWidth = 320;

export const useLayoutStyles = makeStyles()(({ breakpoints, palette, transitions, spacing, mixins }: Theme) => ({
  wrapper: {
    backgroundColor: palette.primary.main,
    height: '100%',
  },
  root: {
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
  },
  drawer: {
    color: palette.secondary.lightest,
    backgroundColor: palette.primary.dark,
    fontWeight: 700,
    borderRight: 0,

    [breakpoints.down('xl')]: {
      transition: transitions.create('width', {
        easing: transitions.easing.sharp,
        duration: transitions.duration.leavingScreen,
      }),
      overflowX: 'hidden',
      width: 112,
    },

    [breakpoints.up('lg')]: {
      width: drawerWidth,
      position: 'static',
      transition: transitions.create('width', {
        easing: transitions.easing.sharp,
        duration: transitions.duration.enteringScreen,
      }),
    },
  },
  toolbar: {
    // necessary for content to be below app bar
    ...(mixins.toolbar as CSSObject),

    display: 'flex',
    alignItems: 'center',
    width: '100%',
    padding: spacing(2, 2, 0, 2),
    marginBottom: spacing(2),

    [breakpoints.down('xl')]: {
      justifyContent: 'center',
    },
    [breakpoints.up('lg')]: {
      justifyContent: 'flex-start',
    },
    cursor: 'pointer',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    padding: spacing(2, 2, 0, 0),
    [breakpoints.up('md')]: {
      padding: spacing(3.5, 2, 0, 0),
    },
    backgroundColor: palette.primary.dark,
    overflow: 'hidden',
    width: 'calc(100% - 80px)', // 100% - small side menu
  },
}));
